module.exports = "/assets/data/d1462bfc29cbacd0af4662545cf3483a-OX39.data.json";